export interface KycIdentificationJson {
  user_id: number;
  workflow_uuid: string;
}

export class KycIdentification {
  constructor(
    public userId: number,
    public workflowUuid: string
  ) {}

  static fromJson(json: KycIdentificationJson): KycIdentification {
    return new KycIdentification(json.user_id, json.workflow_uuid);
  }

  static toJson(kycIdentification: KycIdentification): KycIdentificationJson {
    return {
      user_id: kycIdentification.userId,
      workflow_uuid: kycIdentification.workflowUuid
    };
  }
}
